// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"49":"edb5eb8f","274":"b86a7324","542":"0ebcf17c","641":"b5f0b3a0","701":"73ff0a80","945":"73296ef1"}[chunkId] + ".chunk.js";
};